import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EducationalQualification } from 'util/resources';

export const fetchEducationalQualifications = createAsyncThunk(
  'educationalQualifications/fetch',
  async (_args, thunkAPI) => {
    const options = await EducationalQualification.all();
    return options.all();
  },
);

const slice = createSlice({
  name: 'educationalQualifications',
  initialState: {
    items: [],
    byId: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEducationalQualifications.rejected, (_state, action) => {
      console.error('Error running request', action);
    });
    builder.addCase(fetchEducationalQualifications.fulfilled, (state, action) => {
      state.items = [];
      action.payload.forEach((item) => {
        state.items.push({ label: item.title, value: item.id });
        state.byId[item.id] = item.title;
      });
    });
  },
});

export default slice;
